module.exports = "img/9.a69fb6.webp";